<template>
  <v-form ref="stockItemsForm" :disabled="!isActive">
    <v-simple-table
      fixed-header
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              {{ $$t('goods') }}
            </th>
            <th class="text-left">
              {{ $$t('type') }}
            </th>
            <th class="text-left">
              {{ $$t('sizeRange') }}
            </th>
            <th class="text-left">
              {{ $$t('receivedMass') }}
            </th>
            <th class="text-left">
              {{ $$t('receivedTemp') }}
            </th>
            <th class="text-left">
              {{ $$t('harvestedMass') }}
            </th>
            <th class="text-left">
              {{ $$t('packedMass') }}
            </th>
            <th class="text-left">
              {{ $$t('quantity') }}
            </th>
            <th>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in value"
            :key="item.name"
          >
            <td>
              <v-combobox
                data-cy="TableStockItems-goods"
                :items="listStockTypes"
                v-model="item.stockType"
                @change="goNext($event.target)"
                v-on:keyup.enter="goNext(this)"
              />
            </td>
            <td>
              <v-combobox
                data-cy="TableStockItems-types"
                :items="listTypes"
                v-model="item.type"
              />
            </td>
            <td>
              <v-row no-gutters>
              <v-col cols="5">
                <v-text-field
                  data-cy="TableStockItems-sizeMin"
                  v-model="item.sizeMin"
                  v-on:keyup.enter="goNext($event.target)"
                ></v-text-field>
              </v-col>
              <v-col cols="2" style="margin-top: 5px; font-size: large">
              -
              </v-col>
              <v-col cols="5">
                <v-text-field
                  data-cy="TableStockItems-sizeMax"
                  v-model="item.sizeMax"
                  v-on:keyup.enter="goNext($event.target)"
                ></v-text-field>
              </v-col>
              </v-row>
            </td>
            <td>
              <v-text-field
                data-cy="TableStockItems-receivedMass"
                small
                v-model="item.receivedMass"
                type="number"
                v-on:keyup.enter="goNext($event.target)"
              />
            </td>
            <td>
              <v-text-field
                data-cy="TableStockItems-receivedTemp"
                small
                v-model="item.receivedTemp"
                type="number"
                v-on:keyup.enter="goNext($event.target)"
              />
            </td>
            <td>
              <v-text-field
                data-cy="TableStockItems-harvestedMass"
                small
                v-model="item.harvestedMass"
                type="number"
                v-on:keyup.enter="goNext($event.target)"
              />
            </td>
            <td>
              <v-text-field
                data-cy="TableStockItems-packedMass"
                small
                v-model="item.packedMass"
                type="number"
                v-on:keyup.enter="goNext($event.target)"
              />
            </td>
            <td>
              <v-text-field
                data-cy="TableStockItems-quantity"
                small
                v-model="item.quantity"
                type="number"
                v-on:keyup.enter="goNext($event.target)"
              />
            </td>
            <td>
              <v-btn v-if="isActive" color="error" @click="$emit('remove', item)">
                Delete
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import basicModel from '@codehq/aurora-app-core/src/mixins/basicModel';
import product from '../mixins/product';
import form from '../mixins/form';

export default {
  name: 'TableStockItems',
  module: 'StockItem',
  mixins: [basicModel, loading, product, form],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('stockTypes', ['stockTypes']),
    listStockTypes() {
      return this.stockTypes.map((s) => s.name);
    },
    listTypes() {
      return ['Wild', 'Cultivated', 'Ranched'];
    },
  },
  mounted() {
    this.LOAD_stockTypes();
  },
  methods: {
    ...mapActions('stockTypes', ['LOAD_stockTypes']),
  },
};
</script>
